module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }